module.exports = __webpack_public_path__ + "img/male_2.d31a6a30.png";